export const parseQueryString = (search = '') => search
    .replace(/^\?/, '')
    .split('&')
    .map((kv) => kv.split('='))
    .filter(([key]) => key)
    .reduce((q, [key, val]) => (Object.assign(Object.assign({}, q), { [decodeURIComponent(key)]: decodeURIComponent(val) })), {});
//# sourceMappingURL=parse-query-string.js.map